import { NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import "../assets/css/hrmcrm-sidebar.css";
import logo from "../assets/img/gmt_logo2.png";

export default function SidebarHRMCRM() {
  const [openSection, setOpenSection] = useState(null);
  const location = useLocation();

  const toggleSection = (section) => {
    setOpenSection((prev) => (prev === section ? null : section));
  };

  /* ================= AUTO-OPEN BASED ON ROUTE ================= */
  useEffect(() => {
    const path = location.pathname;

    if (!path.includes("/dashboard")) return;

    if (
      path.includes("/staff") ||
      path.includes("/attendance") ||
      path.includes("/payroll") ||
      path.includes("/performance")
    ) {
      setOpenSection("hrm");
    } else if (
      path.includes("/crm") ||
      path.includes("/leads") ||
      path.includes("/opportunities") ||
      path.includes("/reports")
    ) {
      setOpenSection("crm");
    } else if (path.includes("/settings")) {
      setOpenSection("system");
    } else {
      setOpenSection(null);
    }
  }, [location.pathname]);

  return (
    <div className="hrmcrm-sidebar">
      {/* ================= LOGO ================= */}
      <div className="sidebar-logo">
        <img src={logo} alt="GMT Logo" className="sidebar-logo-img" />
        <div className="sidebar-logo-text">
          <h4>GMT</h4>
          <small>HRM / CRM</small>
        </div>
      </div>

      {/* ================= OVERVIEW ================= */}
      <NavLink
        to="/dashboard/hrmcrm"
        end
        className={({ isActive }) =>
          isActive ? "sidebar-link active" : "sidebar-link"
        }
      >
        <i className="fa fa-home sidebar-icon" />
        <span className="sidebar-text">Overview</span>
      </NavLink>

      {/* ================= HRM OPERATIONS ================= */}
      <div className="sidebar-section">
        <button
          className="sidebar-dropdown-toggle"
          onClick={() => toggleSection("hrm")}
        >
          <div className="sidebar-row">
            <i className="fa fa-users-cog sidebar-icon" />
            <span className="sidebar-text">HRM Operations</span>
          </div>
          <i
            className={`fa fa-chevron-${
              openSection === "hrm" ? "down" : "right"
            } sidebar-chevron`}
          />
        </button>

        {openSection === "hrm" && (
          <div className="sidebar-submenu">
            <NavLink
              to="/dashboard/hrmcrm/staff"
              className={({ isActive }) =>
                isActive ? "sidebar-sublink active" : "sidebar-sublink"
              }
            >
              <i className="fa fa-user-friends sidebar-icon" />
              <span className="sidebar-text">Staff Management</span>
            </NavLink>

            <NavLink
              to="/dashboard/hrmcrm/attendance"
              className={({ isActive }) =>
                isActive ? "sidebar-sublink active" : "sidebar-sublink"
              }
            >
              <i className="fa fa-calendar-check sidebar-icon" />
              <span className="sidebar-text">Attendance</span>
            </NavLink>

            <NavLink
              to="/dashboard/hrmcrm/payroll"
              className={({ isActive }) =>
                isActive ? "sidebar-sublink active" : "sidebar-sublink"
              }
            >
              <i className="fa fa-money-bill-wave sidebar-icon" />
              <span className="sidebar-text">Payroll</span>
            </NavLink>

            <NavLink
              to="/dashboard/hrmcrm/performance"
              className={({ isActive }) =>
                isActive ? "sidebar-sublink active" : "sidebar-sublink"
              }
            >
              <i className="fa fa-chart-line sidebar-icon" />
              <span className="sidebar-text">Performance</span>
            </NavLink>
          </div>
        )}
      </div>

      {/* ================= CRM OPERATIONS ================= */}
      <div className="sidebar-section">
        <button
          className="sidebar-dropdown-toggle"
          onClick={() => toggleSection("crm")}
        >
          <div className="sidebar-row">
            <i className="fa fa-address-book sidebar-icon" />
            <span className="sidebar-text">CRM Operations</span>
          </div>
          <i
            className={`fa fa-chevron-${
              openSection === "crm" ? "down" : "right"
            } sidebar-chevron`}
          />
        </button>

        {openSection === "crm" && (
          <div className="sidebar-submenu">
            <NavLink
              to="/dashboard/hrmcrm/crm"
              className={({ isActive }) =>
                isActive ? "sidebar-sublink active" : "sidebar-sublink"
              }
            >
              <i className="fa fa-users sidebar-icon" />
              <span className="sidebar-text">Customers</span>
            </NavLink>

            <NavLink
              to="/dashboard/hrmcrm/leads"
              className={({ isActive }) =>
                isActive ? "sidebar-sublink active" : "sidebar-sublink"
              }
            >
              <i className="fa fa-user-plus sidebar-icon" />
              <span className="sidebar-text">Leads</span>
            </NavLink>

            <NavLink
              to="/dashboard/hrmcrm/opportunities"
              className={({ isActive }) =>
                isActive ? "sidebar-sublink active" : "sidebar-sublink"
              }
            >
              <i className="fa fa-briefcase sidebar-icon" />
              <span className="sidebar-text">Opportunities</span>
            </NavLink>

            <NavLink
              to="/dashboard/hrmcrm/reports"
              className={({ isActive }) =>
                isActive ? "sidebar-sublink active" : "sidebar-sublink"
              }
            >
              <i className="fa fa-file-alt sidebar-icon" />
              <span className="sidebar-text">Reports</span>
            </NavLink>
          </div>
        )}
      </div>

      {/* ================= SYSTEM SETTINGS ================= */}
      <div className="sidebar-section">
        <button
          className="sidebar-dropdown-toggle"
          onClick={() => toggleSection("system")}
        >
          <div className="sidebar-row">
            <i className="fa fa-cogs sidebar-icon" />
            <span className="sidebar-text">System Settings</span>
          </div>
          <i
            className={`fa fa-chevron-${
              openSection === "system" ? "down" : "right"
            } sidebar-chevron`}
          />
        </button>

        {openSection === "system" && (
          <div className="sidebar-submenu">
            <NavLink
              to="/dashboard/settings/notifications"
              className={({ isActive }) =>
                isActive ? "sidebar-sublink active" : "sidebar-sublink"
              }
            >
              <i className="fa fa-bell sidebar-icon" />
              <span className="sidebar-text">Notifications</span>
            </NavLink>

            <NavLink
  to="/dashboard/hrmcrm/settings"
  className={({ isActive }) =>
    isActive ? "sidebar-sublink active" : "sidebar-sublink"
  }
>
  <i className="fa fa-sliders-h sidebar-icon" />
  <span className="sidebar-text">HRM Settings</span>
</NavLink>
          </div>
        )}
      </div>
    </div>
  );
}
